import { repository } from '@/api/base'

export default {
  async createScheduleGrid(body) {
    const { data } = await repository.post('/testScheduleGrid', body)
    return data
  },

  async findAllScheduleGrid(page, body) {
    const { data } = await repository.post(`/testScheduleGrid/findAll/${page}`, body)
    return data
  },

  async getSchedule(id) {
    const { data } = await repository.get(`/testScheduleGrid/${id}`)
    return data
  },

  async getScheduleCells(id) {
    const { data } = await repository.get(`/testScheduleGrid/${id}/cells`)
    return data
  },
  async moveScheduleCell(id, body) {
    const { data } = await repository.put(`/testScheduleCell/${id}`, body)
    return data
  },

  async createScheduleCell(body) {
    const { data } = await repository.post('/testScheduleCell', body)
    return data
  },

  async addDisciplineScheduleGrid(testScheduleGridId, disciplineOriginalId) {
    const { data } = await repository.post(
      `/testScheduleGrid/${testScheduleGridId}/addDiscipline/${disciplineOriginalId}`
    )
    return data
  },
  async approveScheduleGrid(testScheduleGridId) {
    const { data } = await repository.post(`/testScheduleGrid/${testScheduleGridId}/approve`)
    return data
  },
  async deleteDisciplineScheduleGrid(testScheduleGridId, disciplineOriginalId) {
    const { data } = await repository.post(
      `/testScheduleGrid/${testScheduleGridId}/deleteDiscipline/${disciplineOriginalId}`
    )
    return data
  },
  async generateScheduleGrid(testScheduleGridId) {
    const { data } = await repository.post(`/testScheduleGrid/${testScheduleGridId}/generate`)
    return data
  },
  async deleteScheduleGrid(id) {
    const { data } = await repository.delete(`/testScheduleGrid/${id}`)
    return data
  }
}
